import React from 'react'
import DocTorso from '../media/docTorso.png'
import Hero from 'baseComponents/hero'
import Steps from '../components/hybrid/steps'
import Button from 'material-ui/Button';
import { fonts, colors, applicationStyles } from '../themes'
import Cookies from 'js-cookie'
import WhiteLogo from '../media/OncallogyWhiteFullText.png'
import DoctorCartoon from '../media/FemaleDoctorDarkHair.png'
import Badge from 'material-ui/Badge';
import DoximityLogin from '../components/base/doximityLogin'
import Grid from 'material-ui/Grid';
import presets from 'lib/presets'
import IconPoints from 'components/hybrid/iconPoints'
import Loading from 'components/base/loading'
import { GA } from 'lib/googleAnalytics'

const styles = {
  header: {
    padding: 20,
    backgroundColor: colors.mainBlue,
    width: '100%',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  mainContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    backgroundColor: colors.darkBlue,
    minHeight: '100vh',
    alignItems: 'center',
    justifyContent: 'center',
  },
  innerContainer: {
    padding: 20,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    // Hack for safari :(
    marginBottom: 70,
  },
  doctorCartoon: {
    height: '30vh',
    [presets.Tablet]: {
      height: '50vh',
    },
  },
  doctorCartoonContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    marginTop: 0,
    color: colors.white,
    textAlign: 'center',
  },
  subtitle: {
    color: colors.white,
    paddingTop: 15,
    width: '100%',
    minWidth: '200px',
    marginBottom: 20,
    textAlign: 'center',
    borderTop: `4px solid ${colors.green}`,
  },
  textGrid: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  explanation: {
    color: colors.white,
    textAlign: 'center',
    marginTop: 20,
  },
}

const logo = (
  <Badge style={{color: colors.green }} badgeContent="beta" >
    <img src={WhiteLogo} height={50}/>
  </Badge>
)

class Beta extends React.Component {
  constructor() {
    super()
    this.state = {
      loading: false,
      referralSlug: null,
    }
    this.onClick = this.onClick.bind(this)
  }

  componentDidMount() {
    this.setState({ referralSlug: Cookies.get('referralSlug')})
  }

  onClick() {
    GA('send', {
      hitType: 'event',
      eventCategory: 'Auth',
      eventAction: `Signup`,
      eventLabel: 'Doximity',
    })
    this.setState({ loading: true })
  }

  render() {
    if (this.state.loading) {
      return <Loading />
    }
    return (
      <div css={styles.mainContainer}>
        <div css={styles.header}>
          {logo}
        </div>
        <div css={{...styles.innerContainer, minHeight: '50vh'}}>
          <Grid container spacing={8}>
            <Grid item sm={1}>
            </Grid>
            <Grid item sm={3} style={styles.doctorCartoonContainer}>
              <img src={DoctorCartoon} css={styles.doctorCartoon}/>
            </Grid>
            <Grid item xs={12} sm={7} style={styles.textGrid}>
              <h1 css={styles.title}>
                Moonlighting Simplified.
              </h1>
              <h4 css={styles.subtitle}>
                Sign up with Doximity for early access
              </h4>
              <DoximityLogin
                onClick={this.onClick}
                imageType="verify"
                referralSlug={this.state.referralSlug}
              />
            </Grid>
            <Grid item sm={1}>
            </Grid>
          </Grid>
        </div>
        <div css={styles.innerContainer}>
          <h4> Work on your own time for local hospitals </h4>
          <IconPoints />
        </div>
      </div>
    )
  }
}  

export default Beta


// WEBPACK FOOTER //
// ./src/pages/beta.js